import React from 'react';

const Footer = () => {
  return (
    <div className='list-footer'></div>
  );
};

export default Footer;